import React, { useEffect, useState } from "react";
import { Fade } from '@progress/kendo-react-animation';

//Type: message success, error or info
const FadeConfirmation = (props) => {
    const { apiError, clearMessage } = props;
    const [confirmationOpen, setConfirmationOpen] = useState(true);

    useEffect(() => {
        if (confirmationOpen) {
            const countdownTimeout = setTimeout(() => {
                setConfirmationOpen(false);
                clearMessage();
            }, 4000);

            return () => clearTimeout(countdownTimeout);
        }
    }, [apiError]);

    return (
        <div className="message-animation-container" role="alert">
            {apiError.type && confirmationOpen && <Fade>
                <div className="confirmation css-fade css-icon">
                    <div className={apiError.type}>
                        <span className={apiError.type} aria-hidden="true">
                        </span>
                        {apiError.message}
                    </div>
                </div>
            </Fade>}
        </div>
    );
}
FadeConfirmation.defaultProps = {
    apiError: { type: undefined, message: '' }
}
export default FadeConfirmation;